Drupal.behaviors.richText = {
  attach: function (context, settings) {
    once('bind-resize-table', 'body', context).forEach(el => {
      const resizeTables = () => {
        const windowWidth = window.innerWidth;

        const articleTables = document.querySelectorAll('article table');
        articleTables.forEach((articleTable) => {
          const tableWidth = articleTable.clientWidth;
          if (windowWidth - 50 < tableWidth && windowWidth > 800) {
            articleTable.style.maxWidth = (windowWidth - 100) + 'px';
          }
        });

      };
      resizeTables();
      window.addEventListener('resize', resizeTables);

      //check for external links
      const links = document.querySelectorAll('a');

      links.forEach((link) => {
        const href = link.getAttribute("href");
        if (href && !href.includes("wohnglueck.de") && !href.startsWith("/") && !href.startsWith("#")) {
          if (!link.querySelector("img")) {
            link.classList.add("external-link");
          }
        }
      })
    });
  },
};
